var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "schoolWarp" },
    [
      _c("ZhjySerach", {
        attrs: { queryGroup: _vm.queryGroup, modelData: _vm.modelData },
        on: {
          "update:modelData": function ($event) {
            _vm.modelData = $event
          },
          "update:model-data": function ($event) {
            _vm.modelData = $event
          },
          search: _vm.search,
        },
      }),
      _vm._v(" "),
      _c("FunBtn", {
        attrs: {
          funBtns: _vm.funBtns,
          defaultColumn: _vm.defaultColumn,
          isShowSelectChange: true,
        },
      }),
      _vm._v(" "),
      _c("ZhjyTable", {
        attrs: {
          minWidth: _vm.minWidth,
          tableData: _vm.listData,
          columList: _vm.defaultColumn,
          options: _vm.options,
          pageNum: _vm.page.pageNumber,
          pageSize: _vm.page.pageSize,
          formatters: _vm.formatters,
        },
        on: {
          "update:pageNum": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          "update:page-num": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          signUp: _vm.signUp,
          viewReason: _vm.viewReason,
          showauditbackjindu: _vm.showauditbackjindu,
        },
      }),
      _vm._v(" "),
      _c("ZhjyPagination", {
        attrs: {
          pageNum: _vm.page.pageNumber,
          pageSize: _vm.page.pageSize,
          total: _vm.totalData,
        },
        on: {
          "update:pageNum": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          "update:page-num": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          handleCurrentChange: _vm.handleCurrentChange,
          handleSizeChange: _vm.handleSizeChange,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "logBox pubDia" },
        [
          _c(
            "el-dialog",
            {
              staticClass: "dialoghead excelIn",
              attrs: { title: "退回原因", visible: _vm.causeDia },
              on: {
                "update:visible": function ($event) {
                  _vm.causeDia = $event
                },
              },
            },
            [
              _c("div", { staticClass: "diaWarp" }, [
                _vm._v(_vm._s(_vm.backreason)),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "logBox pubDia" },
        [
          _c(
            "el-dialog",
            {
              staticClass: "dialoghead excelIn",
              attrs: { title: "报名", visible: _vm.applyDia, width: "70%" },
              on: {
                "update:visible": function ($event) {
                  _vm.applyDia = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "diaWarp" },
                [
                  _c("el-row", { staticClass: "applyListWarp" }, [
                    _c("div", { staticClass: "labelName" }, [
                      _vm._v("参赛选手:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "table",
                      {
                        attrs: {
                          border: "1",
                          cellpadding: "0",
                          cellspacing: "0",
                          width: "100%",
                        },
                      },
                      [
                        _c("tr", [
                          _c("td", [_vm._v("姓名")]),
                          _vm._v(" "),
                          _c("td", [_vm._v("手机")]),
                          _vm._v(" "),
                          _c("td", [_vm._v("身份证号")]),
                          _vm._v(" "),
                          _c("td", [_vm._v("邮箱")]),
                          _vm._v(" "),
                          !_vm.isAudit ? _c("td", [_vm._v("操作")]) : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.studentList, function (i, j) {
                          return _c("tr", { key: j }, [
                            _c(
                              "td",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入" },
                                  model: {
                                    value: i.name,
                                    callback: function ($$v) {
                                      _vm.$set(i, "name", $$v)
                                    },
                                    expression: "i.name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入" },
                                  model: {
                                    value: i.mobile,
                                    callback: function ($$v) {
                                      _vm.$set(i, "mobile", $$v)
                                    },
                                    expression: "i.mobile",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入" },
                                  model: {
                                    value: i.idCard,
                                    callback: function ($$v) {
                                      _vm.$set(i, "idCard", $$v)
                                    },
                                    expression: "i.idCard",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入" },
                                  model: {
                                    value: i.email,
                                    callback: function ($$v) {
                                      _vm.$set(i, "email", $$v)
                                    },
                                    expression: "i.email",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.isAudit
                              ? _c(
                                  "td",
                                  [
                                    j === 0
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addPlayer(i)
                                              },
                                            },
                                          },
                                          [_vm._v("添加")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    j > 0
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "danger",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.delPlayer(i, j)
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ])
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-row", { staticClass: "applyListWarp" }, [
                    _c("div", { staticClass: "labelName" }, [
                      _vm._v("指导教师:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "table",
                      {
                        attrs: {
                          border: "1",
                          cellpadding: "0",
                          cellspacing: "0",
                          width: "100%",
                        },
                      },
                      [
                        _c("tr", [
                          _c("td", [_vm._v("指导教师排序")]),
                          _vm._v(" "),
                          _c("td", [_vm._v("姓名")]),
                          _vm._v(" "),
                          _c("td", [_vm._v("手机")]),
                          _vm._v(" "),
                          _c("td", [_vm._v("身份证号")]),
                          _vm._v(" "),
                          _c("td", [_vm._v("邮箱")]),
                          _vm._v(" "),
                          !_vm.isAudit ? _c("td", [_vm._v("操作")]) : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.teacherList, function (i, j) {
                          return _c("tr", { key: j }, [
                            _c("td", [
                              _vm._v(
                                "\n                第" +
                                  _vm._s(i.indexNum) +
                                  "指导教师\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入" },
                                  model: {
                                    value: i.name,
                                    callback: function ($$v) {
                                      _vm.$set(i, "name", $$v)
                                    },
                                    expression: "i.name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "请输入" },
                                          model: {
                                            value: i.mobile,
                                            callback: function ($$v) {
                                              _vm.$set(i, "mobile", $$v)
                                            },
                                            expression: "i.mobile",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "idCard" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "请输入" },
                                          model: {
                                            value: i.idCard,
                                            callback: function ($$v) {
                                              _vm.$set(i, "idCard", $$v)
                                            },
                                            expression: "i.idCard",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "email" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "请输入" },
                                          model: {
                                            value: i.email,
                                            callback: function ($$v) {
                                              _vm.$set(i, "email", $$v)
                                            },
                                            expression: "i.email",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.isAudit
                              ? _c(
                                  "td",
                                  [
                                    j === 0
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addTeacher(i, j)
                                              },
                                            },
                                          },
                                          [_vm._v("添加")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    j > 0
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "danger",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.delTeacher(i, j)
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ])
                        }),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isAudit
                ? _c(
                    "div",
                    { staticClass: "submitBtn" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { loading: _vm.isLoad, type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitApply(0)
                            },
                          },
                        },
                        [_vm._v("保存为草稿")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { loading: _vm.isLoad, type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitApply(1)
                            },
                          },
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.backSubmit } }, [
                        _vm._v("取消"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "审核进度",
                visible: _vm.showauditback,
                width: "30%",
                "before-close": _vm.handleClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showauditback = $event
                },
              },
            },
            _vm._l(_vm.showauditbackList, function (i, j) {
              return _c("div", { key: j, staticClass: "item" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(j + 1) +
                    "、" +
                    _vm._s(i.content) +
                    "\n      "
                ),
              ])
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }